/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  KnowledgeSection,
  KnowledgeSectionRequest,
  KnowledgeSectionsListParams,
  KnowledgeVersion,
  KnowledgeVersionsCompareListParams,
  KnowledgeVersionsListParams,
  PaginatedKnowledgeSectionList,
  PaginatedKnowledgeVersionSummaryList,
  PatchedKnowledgeSectionRequest,
  PublishRequestRequest,
  SectionChange
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Sections of the draft only: published and archived versions are never edited.
 */
export type knowledgeSectionsListResponse200 = {
  data: PaginatedKnowledgeSectionList
  status: 200
}
    
export type knowledgeSectionsListResponseSuccess = (knowledgeSectionsListResponse200) & {
  headers: Headers;
};
;

export type knowledgeSectionsListResponse = (knowledgeSectionsListResponseSuccess)

export const getKnowledgeSectionsListUrl = (params?: KnowledgeSectionsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/knowledge/sections/?${stringifiedParams}` : `/api/v1/knowledge/sections/`
}

export const knowledgeSectionsList = async (params?: KnowledgeSectionsListParams, options?: RequestInit): Promise<knowledgeSectionsListResponse> => {
  
  return apiFetch<knowledgeSectionsListResponse>(getKnowledgeSectionsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getKnowledgeSectionsListQueryKey = (params?: KnowledgeSectionsListParams,) => {
    return [
    `/api/v1/knowledge/sections/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getKnowledgeSectionsListQueryOptions = <TData = Awaited<ReturnType<typeof knowledgeSectionsList>>, TError = unknown>(params?: KnowledgeSectionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeSectionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getKnowledgeSectionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof knowledgeSectionsList>>> = ({ signal }) => knowledgeSectionsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof knowledgeSectionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type KnowledgeSectionsListQueryResult = NonNullable<Awaited<ReturnType<typeof knowledgeSectionsList>>>
export type KnowledgeSectionsListQueryError = unknown


export function useKnowledgeSectionsList<TData = Awaited<ReturnType<typeof knowledgeSectionsList>>, TError = unknown>(
 params: undefined |  KnowledgeSectionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeSectionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeSectionsList>>,
          TError,
          Awaited<ReturnType<typeof knowledgeSectionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKnowledgeSectionsList<TData = Awaited<ReturnType<typeof knowledgeSectionsList>>, TError = unknown>(
 params?: KnowledgeSectionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeSectionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeSectionsList>>,
          TError,
          Awaited<ReturnType<typeof knowledgeSectionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKnowledgeSectionsList<TData = Awaited<ReturnType<typeof knowledgeSectionsList>>, TError = unknown>(
 params?: KnowledgeSectionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeSectionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useKnowledgeSectionsList<TData = Awaited<ReturnType<typeof knowledgeSectionsList>>, TError = unknown>(
 params?: KnowledgeSectionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeSectionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getKnowledgeSectionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Sections of the draft only: published and archived versions are never edited.
 */
export type knowledgeSectionsCreateResponse201 = {
  data: KnowledgeSection
  status: 201
}
    
export type knowledgeSectionsCreateResponseSuccess = (knowledgeSectionsCreateResponse201) & {
  headers: Headers;
};
;

export type knowledgeSectionsCreateResponse = (knowledgeSectionsCreateResponseSuccess)

export const getKnowledgeSectionsCreateUrl = () => {


  

  return `/api/v1/knowledge/sections/`
}

export const knowledgeSectionsCreate = async (knowledgeSectionRequest: KnowledgeSectionRequest, options?: RequestInit): Promise<knowledgeSectionsCreateResponse> => {
  
  return apiFetch<knowledgeSectionsCreateResponse>(getKnowledgeSectionsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      knowledgeSectionRequest,)
  }
);}




export const getKnowledgeSectionsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeSectionsCreate>>, TError,{data: KnowledgeSectionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof knowledgeSectionsCreate>>, TError,{data: KnowledgeSectionRequest}, TContext> => {

const mutationKey = ['knowledgeSectionsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof knowledgeSectionsCreate>>, {data: KnowledgeSectionRequest}> = (props) => {
          const {data} = props ?? {};

          return  knowledgeSectionsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type KnowledgeSectionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof knowledgeSectionsCreate>>>
    export type KnowledgeSectionsCreateMutationBody = KnowledgeSectionRequest
    export type KnowledgeSectionsCreateMutationError = unknown

    export const useKnowledgeSectionsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeSectionsCreate>>, TError,{data: KnowledgeSectionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof knowledgeSectionsCreate>>,
        TError,
        {data: KnowledgeSectionRequest},
        TContext
      > => {

      const mutationOptions = getKnowledgeSectionsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Sections of the draft only: published and archived versions are never edited.
 */
export type knowledgeSectionsRetrieveResponse200 = {
  data: KnowledgeSection
  status: 200
}
    
export type knowledgeSectionsRetrieveResponseSuccess = (knowledgeSectionsRetrieveResponse200) & {
  headers: Headers;
};
;

export type knowledgeSectionsRetrieveResponse = (knowledgeSectionsRetrieveResponseSuccess)

export const getKnowledgeSectionsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/knowledge/sections/${id}/`
}

export const knowledgeSectionsRetrieve = async (id: string, options?: RequestInit): Promise<knowledgeSectionsRetrieveResponse> => {
  
  return apiFetch<knowledgeSectionsRetrieveResponse>(getKnowledgeSectionsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getKnowledgeSectionsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/knowledge/sections/${id}/`
    ] as const;
    }

    
export const getKnowledgeSectionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof knowledgeSectionsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeSectionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getKnowledgeSectionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof knowledgeSectionsRetrieve>>> = ({ signal }) => knowledgeSectionsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof knowledgeSectionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type KnowledgeSectionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof knowledgeSectionsRetrieve>>>
export type KnowledgeSectionsRetrieveQueryError = unknown


export function useKnowledgeSectionsRetrieve<TData = Awaited<ReturnType<typeof knowledgeSectionsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeSectionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeSectionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof knowledgeSectionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKnowledgeSectionsRetrieve<TData = Awaited<ReturnType<typeof knowledgeSectionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeSectionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeSectionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof knowledgeSectionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKnowledgeSectionsRetrieve<TData = Awaited<ReturnType<typeof knowledgeSectionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeSectionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useKnowledgeSectionsRetrieve<TData = Awaited<ReturnType<typeof knowledgeSectionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeSectionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getKnowledgeSectionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Sections of the draft only: published and archived versions are never edited.
 */
export type knowledgeSectionsUpdateResponse200 = {
  data: KnowledgeSection
  status: 200
}
    
export type knowledgeSectionsUpdateResponseSuccess = (knowledgeSectionsUpdateResponse200) & {
  headers: Headers;
};
;

export type knowledgeSectionsUpdateResponse = (knowledgeSectionsUpdateResponseSuccess)

export const getKnowledgeSectionsUpdateUrl = (id: string,) => {


  

  return `/api/v1/knowledge/sections/${id}/`
}

export const knowledgeSectionsUpdate = async (id: string,
    knowledgeSectionRequest: KnowledgeSectionRequest, options?: RequestInit): Promise<knowledgeSectionsUpdateResponse> => {
  
  return apiFetch<knowledgeSectionsUpdateResponse>(getKnowledgeSectionsUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      knowledgeSectionRequest,)
  }
);}




export const getKnowledgeSectionsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeSectionsUpdate>>, TError,{id: string;data: KnowledgeSectionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof knowledgeSectionsUpdate>>, TError,{id: string;data: KnowledgeSectionRequest}, TContext> => {

const mutationKey = ['knowledgeSectionsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof knowledgeSectionsUpdate>>, {id: string;data: KnowledgeSectionRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  knowledgeSectionsUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type KnowledgeSectionsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof knowledgeSectionsUpdate>>>
    export type KnowledgeSectionsUpdateMutationBody = KnowledgeSectionRequest
    export type KnowledgeSectionsUpdateMutationError = unknown

    export const useKnowledgeSectionsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeSectionsUpdate>>, TError,{id: string;data: KnowledgeSectionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof knowledgeSectionsUpdate>>,
        TError,
        {id: string;data: KnowledgeSectionRequest},
        TContext
      > => {

      const mutationOptions = getKnowledgeSectionsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Sections of the draft only: published and archived versions are never edited.
 */
export type knowledgeSectionsPartialUpdateResponse200 = {
  data: KnowledgeSection
  status: 200
}
    
export type knowledgeSectionsPartialUpdateResponseSuccess = (knowledgeSectionsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type knowledgeSectionsPartialUpdateResponse = (knowledgeSectionsPartialUpdateResponseSuccess)

export const getKnowledgeSectionsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/knowledge/sections/${id}/`
}

export const knowledgeSectionsPartialUpdate = async (id: string,
    patchedKnowledgeSectionRequest: PatchedKnowledgeSectionRequest, options?: RequestInit): Promise<knowledgeSectionsPartialUpdateResponse> => {
  
  return apiFetch<knowledgeSectionsPartialUpdateResponse>(getKnowledgeSectionsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedKnowledgeSectionRequest,)
  }
);}




export const getKnowledgeSectionsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeSectionsPartialUpdate>>, TError,{id: string;data: PatchedKnowledgeSectionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof knowledgeSectionsPartialUpdate>>, TError,{id: string;data: PatchedKnowledgeSectionRequest}, TContext> => {

const mutationKey = ['knowledgeSectionsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof knowledgeSectionsPartialUpdate>>, {id: string;data: PatchedKnowledgeSectionRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  knowledgeSectionsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type KnowledgeSectionsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof knowledgeSectionsPartialUpdate>>>
    export type KnowledgeSectionsPartialUpdateMutationBody = PatchedKnowledgeSectionRequest
    export type KnowledgeSectionsPartialUpdateMutationError = unknown

    export const useKnowledgeSectionsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeSectionsPartialUpdate>>, TError,{id: string;data: PatchedKnowledgeSectionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof knowledgeSectionsPartialUpdate>>,
        TError,
        {id: string;data: PatchedKnowledgeSectionRequest},
        TContext
      > => {

      const mutationOptions = getKnowledgeSectionsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Sections of the draft only: published and archived versions are never edited.
 */
export type knowledgeSectionsDestroyResponse204 = {
  data: void
  status: 204
}
    
export type knowledgeSectionsDestroyResponseSuccess = (knowledgeSectionsDestroyResponse204) & {
  headers: Headers;
};
;

export type knowledgeSectionsDestroyResponse = (knowledgeSectionsDestroyResponseSuccess)

export const getKnowledgeSectionsDestroyUrl = (id: string,) => {


  

  return `/api/v1/knowledge/sections/${id}/`
}

export const knowledgeSectionsDestroy = async (id: string, options?: RequestInit): Promise<knowledgeSectionsDestroyResponse> => {
  
  return apiFetch<knowledgeSectionsDestroyResponse>(getKnowledgeSectionsDestroyUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getKnowledgeSectionsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeSectionsDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof knowledgeSectionsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['knowledgeSectionsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof knowledgeSectionsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  knowledgeSectionsDestroy(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type KnowledgeSectionsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof knowledgeSectionsDestroy>>>
    
    export type KnowledgeSectionsDestroyMutationError = unknown

    export const useKnowledgeSectionsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeSectionsDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof knowledgeSectionsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getKnowledgeSectionsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type knowledgeVersionsListResponse200 = {
  data: PaginatedKnowledgeVersionSummaryList
  status: 200
}
    
export type knowledgeVersionsListResponseSuccess = (knowledgeVersionsListResponse200) & {
  headers: Headers;
};
;

export type knowledgeVersionsListResponse = (knowledgeVersionsListResponseSuccess)

export const getKnowledgeVersionsListUrl = (params?: KnowledgeVersionsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/knowledge/versions/?${stringifiedParams}` : `/api/v1/knowledge/versions/`
}

export const knowledgeVersionsList = async (params?: KnowledgeVersionsListParams, options?: RequestInit): Promise<knowledgeVersionsListResponse> => {
  
  return apiFetch<knowledgeVersionsListResponse>(getKnowledgeVersionsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getKnowledgeVersionsListQueryKey = (params?: KnowledgeVersionsListParams,) => {
    return [
    `/api/v1/knowledge/versions/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getKnowledgeVersionsListQueryOptions = <TData = Awaited<ReturnType<typeof knowledgeVersionsList>>, TError = unknown>(params?: KnowledgeVersionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeVersionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getKnowledgeVersionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof knowledgeVersionsList>>> = ({ signal }) => knowledgeVersionsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof knowledgeVersionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type KnowledgeVersionsListQueryResult = NonNullable<Awaited<ReturnType<typeof knowledgeVersionsList>>>
export type KnowledgeVersionsListQueryError = unknown


export function useKnowledgeVersionsList<TData = Awaited<ReturnType<typeof knowledgeVersionsList>>, TError = unknown>(
 params: undefined |  KnowledgeVersionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeVersionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeVersionsList>>,
          TError,
          Awaited<ReturnType<typeof knowledgeVersionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKnowledgeVersionsList<TData = Awaited<ReturnType<typeof knowledgeVersionsList>>, TError = unknown>(
 params?: KnowledgeVersionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeVersionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeVersionsList>>,
          TError,
          Awaited<ReturnType<typeof knowledgeVersionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKnowledgeVersionsList<TData = Awaited<ReturnType<typeof knowledgeVersionsList>>, TError = unknown>(
 params?: KnowledgeVersionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeVersionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useKnowledgeVersionsList<TData = Awaited<ReturnType<typeof knowledgeVersionsList>>, TError = unknown>(
 params?: KnowledgeVersionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeVersionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getKnowledgeVersionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type knowledgeVersionsRetrieveResponse200 = {
  data: KnowledgeVersion
  status: 200
}
    
export type knowledgeVersionsRetrieveResponseSuccess = (knowledgeVersionsRetrieveResponse200) & {
  headers: Headers;
};
;

export type knowledgeVersionsRetrieveResponse = (knowledgeVersionsRetrieveResponseSuccess)

export const getKnowledgeVersionsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/knowledge/versions/${id}/`
}

export const knowledgeVersionsRetrieve = async (id: string, options?: RequestInit): Promise<knowledgeVersionsRetrieveResponse> => {
  
  return apiFetch<knowledgeVersionsRetrieveResponse>(getKnowledgeVersionsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getKnowledgeVersionsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/knowledge/versions/${id}/`
    ] as const;
    }

    
export const getKnowledgeVersionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof knowledgeVersionsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeVersionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getKnowledgeVersionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof knowledgeVersionsRetrieve>>> = ({ signal }) => knowledgeVersionsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof knowledgeVersionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type KnowledgeVersionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof knowledgeVersionsRetrieve>>>
export type KnowledgeVersionsRetrieveQueryError = unknown


export function useKnowledgeVersionsRetrieve<TData = Awaited<ReturnType<typeof knowledgeVersionsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeVersionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeVersionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof knowledgeVersionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKnowledgeVersionsRetrieve<TData = Awaited<ReturnType<typeof knowledgeVersionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeVersionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeVersionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof knowledgeVersionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKnowledgeVersionsRetrieve<TData = Awaited<ReturnType<typeof knowledgeVersionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeVersionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useKnowledgeVersionsRetrieve<TData = Awaited<ReturnType<typeof knowledgeVersionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeVersionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getKnowledgeVersionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Changes from `against` (default: the published version) to this version.
 */
export type knowledgeVersionsCompareListResponse200 = {
  data: SectionChange[]
  status: 200
}
    
export type knowledgeVersionsCompareListResponseSuccess = (knowledgeVersionsCompareListResponse200) & {
  headers: Headers;
};
;

export type knowledgeVersionsCompareListResponse = (knowledgeVersionsCompareListResponseSuccess)

export const getKnowledgeVersionsCompareListUrl = (id: string,
    params?: KnowledgeVersionsCompareListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/knowledge/versions/${id}/compare/?${stringifiedParams}` : `/api/v1/knowledge/versions/${id}/compare/`
}

export const knowledgeVersionsCompareList = async (id: string,
    params?: KnowledgeVersionsCompareListParams, options?: RequestInit): Promise<knowledgeVersionsCompareListResponse> => {
  
  return apiFetch<knowledgeVersionsCompareListResponse>(getKnowledgeVersionsCompareListUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getKnowledgeVersionsCompareListQueryKey = (id?: string,
    params?: KnowledgeVersionsCompareListParams,) => {
    return [
    `/api/v1/knowledge/versions/${id}/compare/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getKnowledgeVersionsCompareListQueryOptions = <TData = Awaited<ReturnType<typeof knowledgeVersionsCompareList>>, TError = unknown>(id: string,
    params?: KnowledgeVersionsCompareListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeVersionsCompareList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getKnowledgeVersionsCompareListQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof knowledgeVersionsCompareList>>> = ({ signal }) => knowledgeVersionsCompareList(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof knowledgeVersionsCompareList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type KnowledgeVersionsCompareListQueryResult = NonNullable<Awaited<ReturnType<typeof knowledgeVersionsCompareList>>>
export type KnowledgeVersionsCompareListQueryError = unknown


export function useKnowledgeVersionsCompareList<TData = Awaited<ReturnType<typeof knowledgeVersionsCompareList>>, TError = unknown>(
 id: string,
    params: undefined |  KnowledgeVersionsCompareListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeVersionsCompareList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeVersionsCompareList>>,
          TError,
          Awaited<ReturnType<typeof knowledgeVersionsCompareList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKnowledgeVersionsCompareList<TData = Awaited<ReturnType<typeof knowledgeVersionsCompareList>>, TError = unknown>(
 id: string,
    params?: KnowledgeVersionsCompareListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeVersionsCompareList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeVersionsCompareList>>,
          TError,
          Awaited<ReturnType<typeof knowledgeVersionsCompareList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKnowledgeVersionsCompareList<TData = Awaited<ReturnType<typeof knowledgeVersionsCompareList>>, TError = unknown>(
 id: string,
    params?: KnowledgeVersionsCompareListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeVersionsCompareList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useKnowledgeVersionsCompareList<TData = Awaited<ReturnType<typeof knowledgeVersionsCompareList>>, TError = unknown>(
 id: string,
    params?: KnowledgeVersionsCompareListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeVersionsCompareList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getKnowledgeVersionsCompareListQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type knowledgeVersionsPublishCreateResponse200 = {
  data: KnowledgeVersion
  status: 200
}
    
export type knowledgeVersionsPublishCreateResponseSuccess = (knowledgeVersionsPublishCreateResponse200) & {
  headers: Headers;
};
;

export type knowledgeVersionsPublishCreateResponse = (knowledgeVersionsPublishCreateResponseSuccess)

export const getKnowledgeVersionsPublishCreateUrl = (id: string,) => {


  

  return `/api/v1/knowledge/versions/${id}/publish/`
}

export const knowledgeVersionsPublishCreate = async (id: string,
    publishRequestRequest: PublishRequestRequest, options?: RequestInit): Promise<knowledgeVersionsPublishCreateResponse> => {
  
  return apiFetch<knowledgeVersionsPublishCreateResponse>(getKnowledgeVersionsPublishCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      publishRequestRequest,)
  }
);}




export const getKnowledgeVersionsPublishCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeVersionsPublishCreate>>, TError,{id: string;data: PublishRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof knowledgeVersionsPublishCreate>>, TError,{id: string;data: PublishRequestRequest}, TContext> => {

const mutationKey = ['knowledgeVersionsPublishCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof knowledgeVersionsPublishCreate>>, {id: string;data: PublishRequestRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  knowledgeVersionsPublishCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type KnowledgeVersionsPublishCreateMutationResult = NonNullable<Awaited<ReturnType<typeof knowledgeVersionsPublishCreate>>>
    export type KnowledgeVersionsPublishCreateMutationBody = PublishRequestRequest
    export type KnowledgeVersionsPublishCreateMutationError = unknown

    export const useKnowledgeVersionsPublishCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeVersionsPublishCreate>>, TError,{id: string;data: PublishRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof knowledgeVersionsPublishCreate>>,
        TError,
        {id: string;data: PublishRequestRequest},
        TContext
      > => {

      const mutationOptions = getKnowledgeVersionsPublishCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * P1-03: an old version becomes the published one again, as a new version.
 */
export type knowledgeVersionsRestoreCreateResponse200 = {
  data: KnowledgeVersion
  status: 200
}
    
export type knowledgeVersionsRestoreCreateResponseSuccess = (knowledgeVersionsRestoreCreateResponse200) & {
  headers: Headers;
};
;

export type knowledgeVersionsRestoreCreateResponse = (knowledgeVersionsRestoreCreateResponseSuccess)

export const getKnowledgeVersionsRestoreCreateUrl = (id: string,) => {


  

  return `/api/v1/knowledge/versions/${id}/restore/`
}

export const knowledgeVersionsRestoreCreate = async (id: string, options?: RequestInit): Promise<knowledgeVersionsRestoreCreateResponse> => {
  
  return apiFetch<knowledgeVersionsRestoreCreateResponse>(getKnowledgeVersionsRestoreCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getKnowledgeVersionsRestoreCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeVersionsRestoreCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof knowledgeVersionsRestoreCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['knowledgeVersionsRestoreCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof knowledgeVersionsRestoreCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  knowledgeVersionsRestoreCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type KnowledgeVersionsRestoreCreateMutationResult = NonNullable<Awaited<ReturnType<typeof knowledgeVersionsRestoreCreate>>>
    
    export type KnowledgeVersionsRestoreCreateMutationError = unknown

    export const useKnowledgeVersionsRestoreCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeVersionsRestoreCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof knowledgeVersionsRestoreCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getKnowledgeVersionsRestoreCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Open (or return) the draft, copied from the published version.
 */
export type knowledgeVersionsDraftCreateResponse200 = {
  data: KnowledgeVersion
  status: 200
}
    
export type knowledgeVersionsDraftCreateResponseSuccess = (knowledgeVersionsDraftCreateResponse200) & {
  headers: Headers;
};
;

export type knowledgeVersionsDraftCreateResponse = (knowledgeVersionsDraftCreateResponseSuccess)

export const getKnowledgeVersionsDraftCreateUrl = () => {


  

  return `/api/v1/knowledge/versions/draft/`
}

export const knowledgeVersionsDraftCreate = async ( options?: RequestInit): Promise<knowledgeVersionsDraftCreateResponse> => {
  
  return apiFetch<knowledgeVersionsDraftCreateResponse>(getKnowledgeVersionsDraftCreateUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getKnowledgeVersionsDraftCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeVersionsDraftCreate>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof knowledgeVersionsDraftCreate>>, TError,void, TContext> => {

const mutationKey = ['knowledgeVersionsDraftCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof knowledgeVersionsDraftCreate>>, void> = () => {
          

          return  knowledgeVersionsDraftCreate(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type KnowledgeVersionsDraftCreateMutationResult = NonNullable<Awaited<ReturnType<typeof knowledgeVersionsDraftCreate>>>
    
    export type KnowledgeVersionsDraftCreateMutationError = unknown

    export const useKnowledgeVersionsDraftCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof knowledgeVersionsDraftCreate>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof knowledgeVersionsDraftCreate>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getKnowledgeVersionsDraftCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * What the AI reads (P1-02).
 */
export type knowledgeVersionsPublishedRetrieveResponse200 = {
  data: KnowledgeVersion
  status: 200
}

export type knowledgeVersionsPublishedRetrieveResponse204 = {
  data: void
  status: 204
}
    
export type knowledgeVersionsPublishedRetrieveResponseSuccess = (knowledgeVersionsPublishedRetrieveResponse200 | knowledgeVersionsPublishedRetrieveResponse204) & {
  headers: Headers;
};
;

export type knowledgeVersionsPublishedRetrieveResponse = (knowledgeVersionsPublishedRetrieveResponseSuccess)

export const getKnowledgeVersionsPublishedRetrieveUrl = () => {


  

  return `/api/v1/knowledge/versions/published/`
}

export const knowledgeVersionsPublishedRetrieve = async ( options?: RequestInit): Promise<knowledgeVersionsPublishedRetrieveResponse> => {
  
  return apiFetch<knowledgeVersionsPublishedRetrieveResponse>(getKnowledgeVersionsPublishedRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getKnowledgeVersionsPublishedRetrieveQueryKey = () => {
    return [
    `/api/v1/knowledge/versions/published/`
    ] as const;
    }

    
export const getKnowledgeVersionsPublishedRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof knowledgeVersionsPublishedRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeVersionsPublishedRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getKnowledgeVersionsPublishedRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof knowledgeVersionsPublishedRetrieve>>> = ({ signal }) => knowledgeVersionsPublishedRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof knowledgeVersionsPublishedRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type KnowledgeVersionsPublishedRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof knowledgeVersionsPublishedRetrieve>>>
export type KnowledgeVersionsPublishedRetrieveQueryError = unknown


export function useKnowledgeVersionsPublishedRetrieve<TData = Awaited<ReturnType<typeof knowledgeVersionsPublishedRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeVersionsPublishedRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeVersionsPublishedRetrieve>>,
          TError,
          Awaited<ReturnType<typeof knowledgeVersionsPublishedRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKnowledgeVersionsPublishedRetrieve<TData = Awaited<ReturnType<typeof knowledgeVersionsPublishedRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeVersionsPublishedRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeVersionsPublishedRetrieve>>,
          TError,
          Awaited<ReturnType<typeof knowledgeVersionsPublishedRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKnowledgeVersionsPublishedRetrieve<TData = Awaited<ReturnType<typeof knowledgeVersionsPublishedRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeVersionsPublishedRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useKnowledgeVersionsPublishedRetrieve<TData = Awaited<ReturnType<typeof knowledgeVersionsPublishedRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof knowledgeVersionsPublishedRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getKnowledgeVersionsPublishedRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




